import {Component, Input} from '@angular/core';
import {School, SchoolGrade, SchoolType} from '../../model/location/School';

@Component({
  selector: 'school-details',
  templateUrl: './school-details.component.html',
  styleUrls: ['./school-details.component.scss']
})
export class SchoolDetailsComponent {

  @Input() school!: School;
  @Input() grade?: SchoolGrade;

  @Input() types?: SchoolType[];

  @Input() compact = false;
  @Input() fullDetails = false;
  @Input() mobile = false;

  constructor() {
  }

  getType(type: string): string {
    if (type && this.types) {
      const schoolType = this.types.find(t => t.id === type);

      return schoolType ? schoolType.name || '' : '';
    }
    return '';
  }
}
